module.exports = __webpack_public_path__ + "static/media/more_vert-24px.3dc9c6f2.svg";